import { Box, Typography } from "@mui/material";
import { OperatingManualStyleContext } from "../../../../../contexts/OperatingManualStyleContext";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

const IntendedUse = () => {
  const { t } = useTranslation();
  const { sectionContainerStyle } = useContext(OperatingManualStyleContext);
  return (
    <Box id="intended-use" sx={{ ...sectionContainerStyle, padding: 3 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          background:
            "linear-gradient(102deg, #5d5cfe -17.62%, #996ad2 30.87%, #f18e8e 87.31%)",
          color: "white",
          p: 1,
          pl: 4,
          borderRadius: 2,
          mb: 2,
          boxShadow: "0px 0.625rem 3rem 0px rgba(0, 0, 0, 0.06)",
        }}
      >
        <Typography variant="h6" fontWeight={"bold"}>
          1.1 {t("operating_manual_intended_use_title")}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          pl: 4,
          pr: 4,
          gap: 2,
        }}
      >
        <Typography fontWeight="bold" sx={{ textDecoration: "underline" }}>
          {t("operating_manual_intended_use_subtitle1")}
        </Typography>
        <Typography>
          {t("operating_manual_intended_use_description1")}
        </Typography>
        <Typography fontWeight="bold" sx={{ textDecoration: "underline" }}>
          {t("operating_manual_intended_use_subtitle2")}
        </Typography>
        <Typography>
          {t("operating_manual_intended_use_description2")}
        </Typography>
        <Typography>
          {t("operating_manual_intended_use_description3")}
        </Typography>
        <Typography>
          {t("operating_manual_intended_use_description4")}
        </Typography>
      </Box>
    </Box>
  );
};

export default IntendedUse;
